import React, { useState } from 'react';
import { HelpCircleIcon, ArrowLeftIcon } from 'lucide-react';
interface QuizQuestionProps {
  question: {
    id: string;
    question: string;
    type: string;
    options?: Array<{
      value: string;
      label: string;
    }>;
    min?: number;
    max?: number;
    minLabel?: string;
    maxLabel?: string;
    tooltip?: string;
    disclaimer?: string;
    required: boolean;
  };
  onAnswer: (answer: any) => void;
  onBack: () => void;
  showBack: boolean;
}
const QuizQuestion: React.FC<QuizQuestionProps> = ({
  question,
  onAnswer,
  onBack,
  showBack
}) => {
  const [selectedOption, setSelectedOption] = useState<string>('');
  const [scaleValue, setScaleValue] = useState<number>(3);
  const [email, setEmail] = useState<string>('');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const handleSubmit = () => {
    if (question.type === 'radio' || question.type === 'dropdown') {
      onAnswer(selectedOption);
    } else if (question.type === 'scale') {
      onAnswer(scaleValue);
    } else if (question.type === 'email') {
      onAnswer(email);
    }
  };
  const renderQuestionContent = () => {
    switch (question.type) {
      case 'radio':
        return <div className="space-y-3 mt-6" data-id="element-238">
            {question.options?.map(option => <button key={option.value} onClick={() => {
            setSelectedOption(option.value);
            setTimeout(() => onAnswer(option.value), 300);
          }} className={`w-full text-left p-4 rounded-md transition-all ${selectedOption === option.value ? 'bg-[#0EB7FF] text-black font-medium' : 'bg-gray-800 hover:bg-gray-700 text-white'}`} data-id="element-239">
                {option.label}
              </button>)}
          </div>;
      case 'dropdown':
        return <div className="mt-6" data-id="element-240">
            <select value={selectedOption} onChange={e => setSelectedOption(e.target.value)} className="w-full p-4 bg-gray-800 rounded-md text-white border border-gray-700 focus:border-[#0EB7FF] focus:ring-1 focus:ring-[#0EB7FF] outline-none" data-id="element-241">
              <option value="" data-id="element-242">Välj ett alternativ</option>
              {question.options?.map(option => <option key={option.value} value={option.value} data-id="element-243">
                  {option.label}
                </option>)}
            </select>
            <button onClick={handleSubmit} disabled={!selectedOption} className={`mt-6 w-full py-3 rounded-md font-medium transition-all ${selectedOption ? 'bg-[#0EB7FF] text-black' : 'bg-gray-700 text-gray-300 cursor-not-allowed'}`} data-id="element-244">
              Fortsätt
            </button>
          </div>;
      case 'scale':
        return <div className="mt-8" data-id="element-245">
            <div className="flex justify-between text-sm text-gray-400 mb-2" data-id="element-246">
              <span data-id="element-247">{question.minLabel}</span>
              <span data-id="element-248">{question.maxLabel}</span>
            </div>
            <div className="flex justify-between space-x-2" data-id="element-249">
              {Array.from({
              length: (question.max || 5) - (question.min || 1) + 1
            }, (_, i) => i + (question.min || 1)).map(value => <button key={value} onClick={() => {
              setScaleValue(value);
              setTimeout(() => onAnswer(value), 300);
            }} className={`flex-1 py-3 rounded-md transition-all ${scaleValue === value ? 'bg-[#0EB7FF] text-black font-medium' : 'bg-gray-800 hover:bg-gray-700 text-white'}`} data-id="element-250">
                  {value}
                </button>)}
            </div>
          </div>;
      case 'email':
        return <div className="mt-6" data-id="element-251">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Din e-postadress (valfritt)" className="w-full p-4 bg-gray-800 rounded-md text-white border border-gray-700 focus:border-[#0EB7FF] focus:ring-1 focus:ring-[#0EB7FF] outline-none" data-id="element-252" />
            {question.disclaimer && <p className="mt-2 text-xs text-gray-400" data-id="element-253">
                {question.disclaimer}
              </p>}
            <div className="mt-6 flex space-x-3" data-id="element-254">
              <button onClick={() => onAnswer('')} className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-md font-medium transition-all" data-id="element-255">
                Hoppa över
              </button>
              <button onClick={() => onAnswer(email)} disabled={email !== '' && !email.includes('@')} className={`flex-1 py-3 rounded-md font-medium transition-all ${email === '' || email.includes('@') ? 'bg-[#0EB7FF] text-black' : 'bg-gray-700 text-gray-300 cursor-not-allowed'}`} data-id="element-256">
                Fortsätt
              </button>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div data-id="element-257">
      <div className="flex items-start mb-2" data-id="element-258">
        <h3 className="text-xl font-semibold flex-1" data-id="element-259">{question.question}</h3>
        {question.tooltip && <div className="relative" data-id="element-260">
            <button onMouseEnter={() => setTooltipVisible(true)} onMouseLeave={() => setTooltipVisible(false)} onClick={() => setTooltipVisible(!tooltipVisible)} className="text-gray-400 hover:text-white" data-id="element-261">
              <HelpCircleIcon className="w-5 h-5" data-id="element-262" />
            </button>
            {tooltipVisible && <div className="absolute right-0 top-full mt-2 p-3 bg-gray-800 rounded-md shadow-lg text-sm text-gray-300 w-64 z-10" data-id="element-263">
                {question.tooltip.replace('VeeloBooster', 'Naturliga lösningar')}
              </div>}
          </div>}
      </div>
      {renderQuestionContent()}
      {showBack && question.type !== 'radio' && question.type !== 'scale' && <button onClick={onBack} className="mt-4 flex items-center text-gray-400 hover:text-white text-sm" data-id="element-264">
          <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-265" />
          Tillbaka
        </button>}
    </div>;
};
export default QuizQuestion;